import { EmptyState, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import {
  deliveryFenceIdsState,
  deliveryFencesPageState,
  deliveryFencesState,
  loadingDeliveryFencesState,
  selectedDeliveryFenceIdState,
} from '../../storage/deliveryFences';
import { DeliveryFenceCore } from '../../types/fence';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import DeliveryFenceFilters from './DeliveryFenceFilters';
import DeliveryFenceItem from './DeliveryFenceItem';

export function DeliveryFenceList() {
  const { theme } = useStyles();
  const deliveryFenceIds = useRecoilValue(deliveryFenceIdsState);
  const setSelectedDeliveryFenceId = useSetRecoilState(selectedDeliveryFenceIdState);
  const resetSelectedFenceId = useResetRecoilState(selectedDeliveryFenceIdState);
  const loadingDeliveryFences = useRecoilValue(loadingDeliveryFencesState);
  const paginatedDeliveryFences = useRecoilValue(deliveryFencesState);
  const setDeliveryFencesPage = useSetRecoilState(deliveryFencesPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedFenceId();
    };
  });

  const onNewDeliveryFence = () => {
    setSelectedDeliveryFenceId('');
  };

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!deliveryFenceIds && !loadingDeliveryFences && <EmptyState title="Todavía no creas ningun punto de entrega." />}
      {!deliveryFenceIds && loadingDeliveryFences && <Loading />}
      {deliveryFenceIds && (
        <>
          <DeliveryFenceFilters />
          <VirtualizedPaginatedList<DeliveryFenceCore>
            ids={deliveryFenceIds}
            loading={loadingDeliveryFences}
            onNextPage={setDeliveryFencesPage}
            paginatedResponse={paginatedDeliveryFences}
            itemComponent={DeliveryFenceItem}
          />
          {!deliveryFenceIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(deliveryFenceIds || !loadingDeliveryFences) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewDeliveryFence}
          startEnhancer={<MaterialIcon name="add" />}
          kind="tertiary"
        >
          Nuevo punto de entrega
        </StyledButton>
      )}
    </FloatingCardContent>
  );
}
